import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { CREATE_FATOR_INIT, UPDATE_FATOR_INIT, FATOR_LIST_FATORES_EMPRESA_INIT, FATOR_OBTEM_FATOR_INIT, DELETE_FATOR_INIT } from '../actionTypes';
import {
  createFatorSucess,
  updateFatorSuccess,
  fatorErrorMsg,
  obtemListaFatoresEmpresaSuccess,
  obtemFatorSuccess,
  deleteFatorSuccess
} from './actions';
import { IFator } from 'src/integracoes/servicos/mongo-atlas/modelos/IFator';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { atualizarFator, criarFator, deletarFator, listarFator, listarfatores } from 'src/integracoes/servicos/mongo-atlas/funcoes/fatores';

// Commmon functions ------------------------------------------------------------------------

interface FetchListaFatoresResult {
  isError: boolean;
  fatores: IFator[] | null;
  errorMessage: string | null;
}

interface FetchFatorResult {
  isError: boolean;
  fator: IFator | null;
  errorMessage: string | null;
}

/* ------------------Lista fatores empresa---------------- */
export const fetchListarFatores = async (empId: string): Promise<FetchListaFatoresResult> => {
  try {
    const { status, dados, mensagem } = await listarfatores(empId);

    if (status && Array.isArray(dados)) {
      return {
        isError: !status,
        fatores: dados,
        errorMessage: mensagem,
      };
    }

    return {
      isError: true,
      fatores: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarFatores({ payload }: { payload: { empId: string }; type: any }) {
  const { empId } = payload;
  try {
    const result: FetchListaFatoresResult = yield call(fetchListarFatores, empId);

    if (!result.isError) {
      yield put(obtemListaFatoresEmpresaSuccess({ fatores: result.fatores }));
    } else {
      yield put(fatorErrorMsg({ msg: result.errorMessage }));
    }
  } catch (error: any) {
    yield put(fatorErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarFatores() {
  yield takeEvery(FATOR_LIST_FATORES_EMPRESA_INIT, parseListarFatores);
}

/* ------------------Lista fator Id ---------------- */
export const fetchListarfatorId = async (id: string): Promise<FetchFatorResult> => {
  try {
    const { status, dados, mensagem } = await listarFator(id);

    if (status) {
      return {
        isError: !status,
        fator: dados as IFator,
        errorMessage: mensagem,
      };
    }

    return {
      isError: true,
      fator: null,
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarFatorId({ payload }: { payload: { id: string }; type: any }) {
  const { id } = payload;
  try {
    const { isError, errorMessage, fator }: FetchFatorResult = yield call(fetchListarfatorId, id);
    if (!isError) {
      yield put(obtemFatorSuccess({ fator: fator }));
    } else {
      yield put(fatorErrorMsg({ msg: errorMessage }));
    }
  } catch (error: any) {
    yield put(fatorErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListarFatorId() {
  yield takeEvery(FATOR_OBTEM_FATOR_INIT, parseListarFatorId);
}

/* ------------------Criar Fator ---------------- */
export const fetchCriarFator = async (fator: any) => {
  try {
    const { status, dados, mensagem } = await criarFator(fator);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarFator({ payload }: { payload: any, type: any }) {
  const { fatorData } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarFator, fatorData);
    if (isCreated) {
      yield put(createFatorSucess({ current: data, msg: msg }));
    } else {
      yield put(fatorErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      fatorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarFator() {
  yield takeEvery(CREATE_FATOR_INIT, parseCriarFator);
}


/* ------------------Atualiza fator ---------------- */
export const fetchAtualizarFator = async (id: string, fator: any) => {
  try {
    const { status, dados, mensagem } = await atualizarFator(id, fator);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarFator({ payload }: { payload: any; type: any }) {
  const { id, fator } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizarFator, id, fator);

    if (isUpdated) {
      yield put(updateFatorSuccess({ msg }));
    } else {
      yield put(fatorErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(

      fatorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarFator() {
  yield takeEvery(UPDATE_FATOR_INIT, parseAtualizarFator);
}

/* ------------------Deletar fator ---------------- */
export const fetchDeletarFator = async (id: string) => {
  try {
    const { status, mensagem } = await deletarFator(id);
    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarFator({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchDeletarFator, id);

    if (isUpdated) {
      yield put(deleteFatorSuccess({ msg }));
    } else {
      yield put(fatorErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      fatorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarFator() {
  yield takeEvery(DELETE_FATOR_INIT, parseDeletarFator);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarFatores),
    fork(watchListarFatorId),
    fork(watchCriarFator),
    fork(watchAtualizarFator),
    fork(watchDeletarFator)
  ]);
}
